(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jj-fitting-support"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('jj-fitting-config');
  if (!config) return;
  const labels = config.dataset;
  const states = new Map();
  const fittingOf = value => /\bring(?:-bound)?\b/i.test(value || '') ? 'ring' : /\bdisc(?:-bound)?\b/i.test(value || '') ? 'disc' : null;
  const setText = (element, text) => { if (element && element.textContent !== text) element.textContent = text; };
  const groupFor = form => Array.from(document.querySelectorAll('[data-jj-fitting]')).find(group => document.getElementById(group.dataset.form) === form);
  const stateFor = (form, group) => {
    const key = `${form.id}:${group.dataset.product}`;
    let state = states.get(key);
    if (!state) {
      state = { product: group.dataset.product, value: null, name: '', pending: false, ready: false };
      states.set(key, state);
    }
    return state;
  };
  function refreshGroup(group) {
    const form = document.getElementById(group.dataset.form);
    if (!form) return;
    const state = stateFor(form, group);
    const variantData = group.closest('variant-picker')?.querySelector('script[data-variant]');
    let variant = null;
    try { variant = JSON.parse(variantData?.textContent || 'null'); } catch {}
    const variantInput = form.querySelector('input[name="id"]');
    if (state.variant && String(state.variant.id) === variantInput?.value) variant = state.variant;
    const picker = group.closest('variant-picker');
    const otherOptionsMatch = Array.from(picker?.querySelectorAll('input[data-option-position]:checked') || []).every(input => group.contains(input) || input.defaultChecked);
    const matched = Boolean(state.value && otherOptionsMatch && variant?.options?.[Number(group.dataset.position) - 1] === state.name && String(variant.id) === variantInput?.value);
    state.ready = Boolean(matched && variant.available && !variantInput.disabled);
    if (matched) state.pending = false;
    group.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === state.value; });
    const message = group.querySelector('[data-jj-fitting-message]');
    setText(message, state.pending ? labels.loading : state.ready ? labels.selected.replace('[fitting]', state.name) : labels.choose);
    const property = form.querySelector('[data-jj-fitting-property]');
    if (property) { property.disabled = !state.ready; property.value = state.ready ? state.name : ''; }
    const button = form.querySelector('buy-buttons button[type="submit"]');
    if (button && !button.disabled && button.getAttribute('aria-busy') !== 'true') {
      setText(button, state.pending ? labels.loading : state.ready ? labels[fittingOf(state.name)] : labels.choose);
    }
  }
  const refresh = () => document.querySelectorAll('[data-jj-fitting]').forEach(refreshGroup);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches?.('input[data-option-position]')) return;
    const form = input.form;
    const group = form && groupFor(form);
    if (!group) return;
    const state = stateFor(form, group);
    if (input.matches('[data-fitting-name]')) { state.value = input.value; state.name = input.dataset.fittingName; }
    state.ready = false;
    state.pending = Boolean(state.value);
    refreshGroup(group);
  }, true);
  document.addEventListener('product:rerender', () => queueMicrotask(refresh), true);
  document.addEventListener('variant:change', event => {
    const form = document.getElementById(event.target.getAttribute('id')) || event.target;
    const group = groupFor(form);
    if (!group) return;
    const state = stateFor(form, group);
    const variant = event.detail.variant;
    state.variant = variant;
    const matched = variant?.options?.[Number(group.dataset.position) - 1] === state.name;
    state.pending = false;
    state.ready = Boolean(state.value && matched && variant.available);
    refreshGroup(group);
  });
  document.addEventListener('submit', event => {
    const group = groupFor(event.target);
    if (!group) return;
    refreshGroup(group);
    const state = stateFor(event.target, group);
    if (!state.ready) {
      event.preventDefault();
      event.stopImmediatePropagation();
      refreshGroup(group);
      group.querySelector('input:checked, input')?.focus();
    }
  }, true);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; refresh(); });
  }).observe(document.body, { childList: true, subtree: true });
  refresh();

  let drawerAttempts = 0;
  function protectDrawerShortcuts() {
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root) {
      if (++drawerAttempts < 120) setTimeout(protectDrawerShortcuts, 500);
      return;
    }
    const style = document.createElement('style');
    style.textContent = ':host([data-jj-fitting-cart]) .upcart-public-express-payments__container { display: none !important; }';
    root.append(style);
    const update = () => {
      const hasFitting = Array.from(root.querySelectorAll('.upcart-internal-cart-items__key-value-pair')).some(node => /\b(?:ring|disc)-bound\b/i.test(node.textContent));
      root.host.toggleAttribute('data-jj-fitting-cart', hasFitting);
    };
    new MutationObserver(update).observe(root, { childList: true, subtree: true, characterData: true });
    update();
  }
  protectDrawerShortcuts();

  const dialog = document.getElementById('jj-fitting-warning');
  const bypass = new WeakSet();
  let busy = false;
  let resume = null;
  let previousFocus = null;
  let approvedSignature = null;
  let initialsSignature = null;
  function compatibility(items) {
    const inserts = items.filter(item => /\b(?:ring|disc)-bound\b/i.test(item.variant_title || ''));
    const systems = new Set(items.flatMap(item => {
      const type = (item.product_type || '').toLowerCase();
      if (type === 'ring binder') return ['ring'];
      if (['disc cover', 'disc binder', 'disc planner', 'disc system'].includes(type)) return ['disc'];
      return [];
    }));
    const mixed = new Set(inserts.map(item => fittingOf(item.variant_title))).size > 1;
    const mismatches = inserts.filter(item => systems.size === 1 && !systems.has(fittingOf(item.variant_title)));
    return { items: mismatches.length ? mismatches : mixed && systems.size < 2 ? inserts : [], mismatch: mismatches.length > 0 };
  }
  function showWarning(message, items, action, trigger, initials = false) {
    resume = action;
    previousFocus = trigger;
    setText(dialog.querySelector('#jj-fitting-warning-title'), initials ? labels.initialsTitle : labels.warningTitle);
    setText(dialog.querySelector('[data-jj-continue]'), initials ? labels.initialsContinue : labels.fittingContinue);
    dialog.querySelector('[data-jj-fitting-advice]').hidden = initials;
    setText(dialog.querySelector('#jj-fitting-warning-message'), message);
    const list = dialog.querySelector('[data-jj-warning-items]');
    list.replaceChildren(...items.map(item => {
      const li = document.createElement('li');
      li.textContent = `${item.product_title || item.title} — ${item.variant_title}`;
      return li;
    }));
    dialog.showModal();
  }
  async function check(trigger, action) {
    if (busy) return;
    busy = true;
    trigger.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(labels.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const signature = JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price, item.properties]));
      const afterFittings = () => {
        if (!cart.items.length || initialsSignature === signature) return action();
        showWarning(labels.initialsMessage, [], () => { initialsSignature = signature; action(); }, trigger, true);
      };
      const result = compatibility(cart.items);
      if (result.items.length && signature !== approvedSignature) showWarning(result.mismatch ? labels.mismatch : labels.mixed, result.items, () => { approvedSignature = signature; afterFittings(); }, trigger);
      else afterFittings();
    } catch {
      showWarning(labels.error + '\n\n' + labels.initialsMessage, [], action, trigger);
    } finally {
      busy = false;
      trigger.removeAttribute('aria-busy');
    }
  }
  dialog.querySelector('[data-jj-review]').addEventListener('click', () => {
    resume = null;
    dialog.close();
    window.location.assign(labels.cartUrl);
  });
  dialog.querySelector('[data-jj-continue]').addEventListener('click', () => {
    const action = resume;
    resume = null;
    dialog.close();
    action?.();
  });
  dialog.addEventListener('close', () => { previousFocus?.focus(); });
  window.addEventListener('click', event => {
    const trigger = event.composedPath().find(node => node.matches?.('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], .upcart-checkout-button'));
    if (!trigger || bypass.has(trigger)) return;
    if (trigger.matches('a')) {
      const url = new URL(trigger.href, location.href);
      if (url.origin !== location.origin || !trigger.matches('.upcart-checkout-button') && !/\/checkout(?:\/|$)/.test(url.pathname)) return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    check(trigger, () => {
      bypass.add(trigger);
      if (trigger.form) bypass.add(trigger.form);
      trigger.click();
      bypass.delete(trigger);
      if (trigger.form) setTimeout(() => bypass.delete(trigger.form), 0);
    });
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('form[action*="/cart"]') || form.action.includes('/cart/add') || bypass.has(form)) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter;
    check(submitter || form, () => {
      bypass.add(form);
      form.requestSubmit(submitter || undefined);
      setTimeout(() => bypass.delete(form), 0);
    });
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
